import './App.css'
import TraficLand from './components/trafic-land/TraficLand'

import PixelScripts from './components/PixelScripts'
import { ToasterComponent } from './features/toaster'

function App() {
    return (
        <div>
            <PixelScripts />
            <TraficLand />
            <div id="modals" />
            <ToasterComponent />
        </div>
    )
}

export default App
